// Auth
export const LOGIN_EXITOSO = "LOGIN_EXITOSO";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const CERRAR_SESION = "CERRAR_SESION";

// User
export const OBTENER_USUARIO = "OBTENER_USUARIO";

// Projects
export const OBTENER_PROJECTS = "OBTENER_PROJECTS";
export const GET_ALL_PROJECTS = "GET_ALL_PROJECTS";
export const ADD_PROJECTS = "ADD_PROJECTS";
export const UPDATE_PROJECTS = "UPDATE_PROJECTS";

// Users
export const GET_ALL_USERS = "GET_ALL_USERS";
export const OBTENER_USER = "OBTENER_USER";
export const ADD_USERS = "ADD_USERS";
export const UPDATE_USERS = "UPDATE_USERS";

// Brands
export const GET_ALL_BRANDS = "GET_ALL_BRANDS";
export const OBTENER_BRANDS = "OBTENER_BRANDS";
export const ADD_BRANDS = "ADD_BRANDS";
export const UPDATE_BRANDS = "UPDATE_BRANDS";

// Roles
export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const OBTENER_ROLES = "OBTENER_ROLES";
export const ADD_ROLES = "ADD_ROLES";
export const UPDATE_ROLES = "UPDATE_ROLES";

// Permisos
export const GET_ALL_PERMISOS = "GET_ALL_PERMISOS";
export const OBTENER_PERMISOS = "OBTENER_PERMISOS";
export const ADD_PERMISOS = "ADD_PERMISOS";
export const UPDATE_PERMISOS = "UPDATE_PERMISOS";
